import { noop } from 'lodash';

export const useIosAtt = () => {
  return {
    requestIosAttPermissions: noop,
  };
};
